import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { transactionReportCode, transactionReportCodeResponse } from "./ReportingData/TransactionReportCode";

const languageMap = {
    curl: 'bash',
    java: 'java',
    "C#": 'csharp',
    python: 'python',
    JavaScript: 'javascript'
};

const TransactionReport = () => {
    const [selectedLanguageTransactionReport, setSelectedLanguageTransactionReport] = useState('curl');
    const [copyStatus, setCopyStatus] = useState({ type: '', isCopied: false });

    const handleSelectedCode = (language) => {
        setSelectedLanguageTransactionReport(language);
    };

    const handleCopyClick = (type) => {
        const textToCopy = type === 'transactionReport' ? transactionReportCode[selectedLanguageTransactionReport].request : transactionReportCodeResponse;
        navigator.clipboard.writeText(textToCopy)
        .then(() => {
            setCopyStatus({ type, isCopied: true });
            setTimeout(() => {
                setCopyStatus({ type: '', isCopied: false });
            }, 1000);
        })
        .catch((error) => {
            console.error('Error copying text: ', error);
            alert('Failed to copy text. Please try again.');
        });
};


return (
    <section className="docs-section" id="transaction-report">

                <div className="row flexbox">

                    <div className="col-md-5">
                        <h2 className="section-heading">Transaction Report</h2>
                        <p><span className="badge badge-secondary back-green">GET</span><span className="api"> /in-store/api/v1/terminal/{`{`}TerminalId{`}`}/transactionReport</span></p>
                        <p>Service to get transaction report by Terminal ID</p>

                        <h4>Parameters</h4>

                        <div className="property-tab col-md-10 border-bottom">
                            <p required><span className="badge badge-secondary name">TerminalId</span> &nbsp; &nbsp; <b>string</b></p>
                            <p className="description">Terminal ID of the device</p>
                        </div>
                        <div className="property-tab col-md-10 border-bottom">
                            <p required><span className="badge badge-secondary name">StartDate</span> &nbsp; &nbsp; <b>string</b></p>
                            <p className="description">Report start date and time in <span style={{ fontWeight: "bold" }}>YYYY-MM-DDTHH:MM:SS.sssZ</span> format</p>
                        </div>
                        <div className="property-tab col-md-10 border-bottom">
                            <p required><span className="badge badge-secondary name">EndDate</span> &nbsp; &nbsp; <b>string</b></p>
                            <p className="description">Report end date and time in <span style={{ fontWeight: "bold" }}>YYYY-MM-DDTHH:MM:SS.sssZ</span> format</p>
                        </div>

                        <br />

                        <div className="response-codes">

                            <h4>Response Codes</h4>

                            <div className="table-wrapper">

                                <h6 className="header">HTTP Status code summary</h6>

                                <table>
                                    <tbody>
                                        <tr>
                                            <td>200 Success</td>
                                            <td>Some text should go here</td>
                                        </tr>
                                        <tr>
                                            <td>400 Bad Request</td>
                                            <td>Some text should go here</td>
                                        </tr>
                                        <tr>
                                            <td>401 Unauthorized</td>
                                            <td>Request requires authentication, and the provided credentials are either missing, invalid, or insufficient, hence send a valid merchant access token (Bearer) issued by Westpay in the "Authorization" header</td>
                                        </tr>
                                        <tr>
                                            <td>409 Conflict</td>
                                            <td>Some text should go here</td>
                                        </tr>
                                        <tr>
                                            <td>422 Client Error</td>
                                            <td>Some text should go here</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                        </div>
                    </div>

                    <div className="col-md-7 code-segments">
                    <div className="docs-code-block">
                    <pre tabIndex="-1" className="shadow-lg rounded">
                            <code className="language-dockerfile hljs">
                                <div className="row code-header">
                                    <div className="col-md-10 languages">
                                        <span>Request</span>
                                        {Object.keys(transactionReportCode).map(language => (
                                            <React.Fragment key={language}>
                                                <input type="radio" name="transactionReport" id={`${language}TransactionReport`} onClick={() => handleSelectedCode(language)} checked={selectedLanguageTransactionReport === language} />
                                                <label htmlFor={`${language}TransactionReport`} className="language">{language}</label>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                    <div className="col-md-2">
                                        {copyStatus.type !== 'transactionReport' && <span className="copy-btn" title="Copy" onClick={() => handleCopyClick("transactionReport")}><i className="fa fa-copy"></i></span>}
                                        {copyStatus.type === 'transactionReport' && copyStatus.isCopied && <div className="copy-message">Copied &#x2713;</div>}
                                    </div>
                                </div>
                                <div className="code-section">
                                    <SyntaxHighlighter language={languageMap[selectedLanguageTransactionReport]} style={dracula} showLineNumbers>
                                        {transactionReportCode[selectedLanguageTransactionReport].request}
                                    </SyntaxHighlighter>
                                </div>
                            </code>
                        </pre>
                    </div>
                    <div className="docs-code-block">
                    <pre tabIndex="-1" className="shadow-lg rounded">
                            <code className="language-dockerfile hljs">
                                <div className="row code-header">
                                    <div className="col-md-10 languages">
                                        <span>Response</span>
                                    </div>
                                    <div className="col-md-2">
                                        {copyStatus.type !== 'transactionReportResponse' && <span className="copy-btn" title="Copy" onClick={() => handleCopyClick("transactionReportResponse")}><i className="fa fa-copy"></i></span>}
                                        {copyStatus.type === 'transactionReportResponse' && copyStatus.isCopied && <div className="copy-message">Copied &#x2713;</div>}
                                    </div>
                                </div>
                                <div className="code-section">
                                    <SyntaxHighlighter language="json" style={dracula} showLineNumbers>
                                        {transactionReportCodeResponse}
                                    </SyntaxHighlighter>
                                </div>
                            </code>
                        </pre>
                    </div>
                </div>

                </div>

            </section>
);
};

export default TransactionReport;